import React from 'react';

export default function TutorialModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-slate-950/80 backdrop-blur-sm flex items-center justify-center p-4 z-50 animate-fadeIn">
      <div className="bg-slate-900 border border-slate-800 rounded-3xl max-w-2xl w-full p-6 md:p-8 relative shadow-2xl text-left space-y-4 max-h-[85vh] overflow-y-auto">
        <button 
          onClick={onClose}
          className="absolute top-5 right-5 text-slate-400 hover:text-white font-bold text-xl bg-slate-800 w-8 h-8 rounded-full flex items-center justify-center transition cursor-pointer"
          aria-label="Cerrar modal"
        >
          ✕
        </button>

        <div className="flex items-center space-x-3">
          <span className="text-3xl">🚀</span>
          <div>
            <h3 className="text-xl md:text-2xl font-bold text-white">¿Cómo funciona English EOH?</h3>
            <p className="text-xs text-slate-400">Guía rápida de uso de la plataforma pedagógica 2026</p>
          </div>
        </div>

        <hr className="border-slate-800" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-xs">
          <div className="bg-slate-950 p-4 rounded-2xl border border-slate-800 space-y-2">
            <div className="font-bold text-blue-400 text-sm flex items-center gap-2">
              <span>1. 🏫</span> Modelo Pedagógico EOH
            </div>
            <p className="text-slate-300 leading-relaxed">
              Basado en <strong>Task-Based Learning (TBL)</strong>. Aprendes inglés a través de retos prácticos, desarrollo de vocabulario en contexto y preparación para las Pruebas Saber ICFES.
            </p>
          </div>

          <div className="bg-slate-950 p-4 rounded-2xl border border-slate-800 space-y-2">
            <div className="font-bold text-emerald-400 text-sm flex items-center gap-2">
              <span>2. 🔑</span> Sistema de Acceso
            </div>
            <p className="text-slate-300 leading-relaxed">
              Regístrate en <strong>Acceso Estudiantes</strong> con tu Nombre, Grado y Fecha de Nacimiento. El sistema generará tu <strong>Código Único EOH</strong> para ingresar siempre.
            </p>
          </div>

          <div className="bg-slate-950 p-4 rounded-2xl border border-slate-800 space-y-2">
            <div className="font-bold text-indigo-400 text-sm flex items-center gap-2">
              <span>3. 📘</span> Módulos (6°, 7° y 9°)
            </div>
            <p className="text-slate-300 leading-relaxed">
              Cada grado tiene 5 Unidades. En cada unidad encuentras el <strong>Bloque 1 (Taller 20 Ejercicios)</strong> y el <strong>Bloque 2 (Práctica ICFES 10 Preguntas)</strong>.
            </p>
          </div>

          <div className="bg-slate-950 p-4 rounded-2xl border border-slate-800 space-y-2">
            <div className="font-bold text-purple-400 text-sm flex items-center gap-2">
              <span>4. 🤖</span> Tutor Virtual Profesor Didier AI
            </div>
            <p className="text-slate-300 leading-relaxed">
              Chatea 24/7 con el <strong>Profesor Didier AI</strong> en Gemini para practicar conversación, pedir explicaciones de gramática, traducir o corregir tu redacción en inglés.
            </p>
          </div>

          <div className="bg-slate-950 p-4 rounded-2xl border border-slate-800 space-y-2">
            <div className="font-bold text-amber-400 text-sm flex items-center gap-2">
              <span>5. 🏆</span> Puntos XP y Rankings
            </div>
            <p className="text-slate-300 leading-relaxed">
              Gana <strong>+10 XP</strong> por cada respuesta correcta. Tu profesor podrá monitorear tus avances en tiempo real desde el <strong>Panel Docente</strong>.
            </p>
          </div>

          <div className="bg-slate-950 p-4 rounded-2xl border border-slate-800 space-y-2">
            <div className="font-bold text-sky-400 text-sm flex items-center gap-2">
              <span>6. 📧</span> Soporte e Interacción
            </div>
            <p className="text-slate-300 leading-relaxed">
              Escribe dudas en el buzón de <strong>Mensajes al Profe</strong> o envía un correo oficial a <strong className="text-white">didier.alvarez@medellin.edu.co</strong>.
            </p>
          </div>
        </div>

        <button
          onClick={onClose}
          className="w-full bg-blue-600 hover:bg-blue-500 text-white font-bold py-3 rounded-xl transition shadow-lg text-sm mt-4 cursor-pointer"
        >
          ¡Entendido, a romperla! 🔥
        </button>
      </div>
    </div>
  );
}
